import React from 'react'
import { Jumbotron, Container } from 'react-bootstrap'

export default function About() {
    return (
        <Jumbotron fluid>
                <Container>
                    <h1 style={{fontSize: '3rem'}}>ABOUT</h1>
                    <h3>
                    Head on over to the shop to check out all of the Fortnite skins and other cosmetics available in the Fortnite Item shop today.
                    </h3>
                </Container>
            </Jumbotron>
    )
}
